// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"2c58cf1c","459":"71c6a396"}[chunkId] + ".chunk.css";
};